var map = {
	"./Abbadog-menu.png": 15583,
	"./Acegon-menu.png": 52546,
	"./Aferaid-menu.png": 88957,
	"./Agita-menu.png": 14467,
	"./Algon-menu.png": 78616,
	"./Anima-menu.png": 11455,
	"./Antarzen-menu.png": 72,
	"./Antlorm-menu.png": 3730,
	"./Arctivore_(Extinction)-menu.png": 91551,
	"./Arispauva-menu.png": 68293,
	"./Arqua_(Extinction)-menu.png": 56488,
	"./Auga-menu.png": 89829,
	"./Babicle-menu.png": 49261,
	"./Bactoul-menu.png": 47137,
	"./Baloompa-menu.png": 69400,
	"./Barboraco-menu.png": 93114,
	"./Basil-menu.png": 51920,
	"./Bedam_(Extinction)-menu.png": 90839,
	"./Behilda-menu.png": 11062,
	"./Bira-menu.png": 63263,
	"./Biralo-menu.png": 79462,
	"./Bisina-menu.png": 15119,
	"./Blazetilia-menu.png": 9340,
	"./Blimpapa-menu.png": 76299,
	"./Blit-menu.png": 69388,
	"./Blizstrong-menu.png": 35109,
	"./Blizzarm-menu.png": 79974,
	"./Blizzaur-menu.png": 68948,
	"./Bloomriol-menu.png": 75470,
	"./Bloopish-menu.png": 15463,
	"./Blublub-menu.png": 38023,
	"./Bogarp_(Extinction)-menu.png": 42767,
	"./Boilgog-menu.png": 50930,
	"./Bolzen-menu.png": 11613,
	"./Bombargrof-menu.png": 81356,
	"./Bomblasta-menu.png": 72324,
	"./Bomriol-menu.png": 20099,
	"./Boscage-menu.png": 55611,
	"./Bouldcran-menu.png": 57667,
	"./Bouldion-menu.png": 33495,
	"./Braccus-menu.png": 30450,
	"./Branipus-menu.png": 78301,
	"./Brauncer-menu.png": 99469,
	"./Briar-menu.png": 94635,
	"./Broshield_(Extinction)-menu.png": 41876,
	"./Brumenie-menu.png": 47512,
	"./Brumtler-menu.png": 22,
	"./Bulbrit-menu.png": 72461,
	"./Bullogan-menu.png": 96503,
	"./Bushnome-menu.png": 93780,
	"./Byeol-menu.png": 15796,
	"./Cadeto-menu.png": 2649,
	"./Caelesa-menu.png": 86367,
	"./Calfter-menu.png": 67986,
	"./Calplex-menu.png": 33998,
	"./Candly-menu.png": 85906,
	"./Caninui-menu.png": 23084,
	"./Carcaros-menu.png": 67645,
	"./Carnagrius_(Extinction)-menu.png": 45383,
	"./Centeror-menu.png": 87187,
	"./Cerebrius-menu.png": 68779,
	"./Chaparral-menu.png": 74919,
	"./Chibbit-menu.png": 7432,
	"./Chirrent-menu.png": 40688,
	"./Chowser-menu.png": 94858,
	"./Cloddy-menu.png": 81724,
	"./Columbra_(Extinction)-menu.png": 3721,
	"./Coral-menu.png": 34790,
	"./Couplet-menu.png": 61419,
	"./Cranillow-menu.png": 67608,
	"./Cranoad-menu.png": 29397,
	"./Cromeon-menu.png": 68826,
	"./Croncho-menu.png": 82123,
	"./Croo-menu.png": 52232,
	"./Cruff-menu.png": 24595,
	"./Cryzzard-menu.png": 18210,
	"./Cubdy-menu.png": 78202,
	"./Cuisizle-menu.png": 36583,
	"./Dalsae-menu.png": 85859,
	"./Darine_(Extinction)-menu.png": 92157,
	"./Deebuz-menu.png": 65824,
	"./Deember-menu.png": 44305,
	"./Devoul-menu.png": 5410,
	"./Deyam-menu.png": 3107,
	"./Deyama-menu.png": 30652,
	"./Dichala-menu.png": 87259,
	"./Dinja-menu.png": 82177,
	"./Divette-menu.png": 40022,
	"./Domigator-menu.png": 52111,
	"./Dracly-menu.png": 63846,
	"./Dracon-menu.png": 69760,
	"./Draniphant-menu.png": 59542,
	"./Drare-menu.png": 83287,
	"./Dratter-menu.png": 78845,
	"./Dreaver-menu.png": 91802,
	"./Dreddiful-menu.png": 82896,
	"./Dredmore-menu.png": 83849,
	"./Dredrone-menu.png": 66826,
	"./Duh-menu.png": 74866,
	"./Duktar-menu.png": 82400,
	"./Durtacles-menu.png": 57364,
	"./Enercer-menu.png": 23701,
	"./Eqo-menu.png": 45296,
	"./Eqoloptera-menu.png": 63211,
	"./Eurus-menu.png": 10299,
	"./Excravator-menu.png": 6240,
	"./Fainglori-menu.png": 44364,
	"./Fandiose-menu.png": 82368,
	"./Fane-menu.png": 69523,
	"./Fanling-menu.png": 16478,
	"./Faucefant-menu.png": 96084,
	"./Felarnia-menu.png": 1847,
	"./Felclaw-menu.png": 57995,
	"./Feliblanqo-menu.png": 63120,
	"./Felicient_(Extinction)-menu.png": 64697,
	"./Ferodile_(Extinction)-menu.png": 87986,
	"./Fistuff-menu.png": 28914,
	"./Flizard-menu.png": 74345,
	"./Florauga-menu.png": 13758,
	"./Floreina-menu.png": 22843,
	"./Florozard-menu.png": 31004,
	"./Flotter-menu.png": 44839,
	"./Folicurse-menu.png": 48597,
	"./Fona_(Extinction)-menu.png": 70174,
	"./Foreer-menu.png": 23690,
	"./Fortank-menu.png": 93588,
	"./Fortle-menu.png": 21881,
	"./Fortoise-menu.png": 94378,
	"./Foxdra-menu.png": 91761,
	"./Frictingle-menu.png": 84608,
	"./Frogick-menu.png": 39892,
	"./Frominence-menu.png": 58855,
	"./Froppe_(Extinction)-menu.png": 46200,
	"./Fulmina-menu.png": 38191,
	"./Furrygon-menu.png": 53975,
	"./Gekoko-menu.png": 71983,
	"./Gemaxar-menu.png": 27358,
	"./Gemeen_(Extinction)-menu.png": 64239,
	"./Gemock-menu.png": 49817,
	"./Ghouze-menu.png": 64081,
	"./Giddiyelp-menu.png": 26674,
	"./Glamond-menu.png": 61939,
	"./Glamoory-menu.png": 1701,
	"./Glidlee-menu.png": 57295,
	"./Glimoory-menu.png": 60461,
	"./Globlob-menu.png": 12456,
	"./Glontern-menu.png": 88182,
	"./Glunch-menu.png": 4344,
	"./Goateeze-menu.png": 64971,
	"./Goatlanche-menu.png": 85051,
	"./Goblat-menu.png": 24894,
	"./Gomarm-menu.png": 50314,
	"./Graciful-menu.png": 17744,
	"./Gradow-menu.png": 7025,
	"./Graloon-menu.png": 97635,
	"./Grath-menu.png": 11331,
	"./Gravello-menu.png": 10821,
	"./Grebal-menu.png": 41372,
	"./Greben-menu.png": 24886,
	"./Griff-menu.png": 77099,
	"./Griffgar-menu.png": 98501,
	"./Grimmon-menu.png": 4964,
	"./Grunda_(Extinction)-menu.png": 10475,
	"./Guazharm-menu.png": 45842,
	"./Gurgita-menu.png": 30390,
	"./Hainok-menu.png": 91813,
	"./Harectic-menu.png": 31310,
	"./Heddeca-menu.png": 9677,
	"./Helipa-menu.png": 76996,
	"./Heliventus-menu.png": 82496,
	"./Heliwurm-menu.png": 38930,
	"./Helovolk-menu.png": 74479,
	"./Hexia_(Extinction)-menu.png": 75769,
	"./Hinazuru-menu.png": 2337,
	"./Hoglet-menu.png": 21296,
	"./Hohopi-menu.png": 95068,
	"./Holoch-menu.png": 92336,
	"./Horget-menu.png": 73856,
	"./Hurristag_(Extinction)-menu.png": 54611,
	"./Hydrip-menu.png": 51375,
	"./Hydrose-menu.png": 9729,
	"./Hyphoon-menu.png": 1230,
	"./Ignigon-menu.png": 89688,
	"./Imburion-menu.png": 20700,
	"./Imbuzi-menu.png": 97853,
	"./Immortis-menu.png": 16011,
	"./Inominox-menu.png": 20484,
	"./Jeeta_(Extinction)-menu.png": 26093,
	"./Jeliflo-menu.png": 80886,
	"./Jeliflux-menu.png": 4150,
	"./Jeloon-menu.png": 6794,
	"./Kamelevo-menu.png": 59353,
	"./Kawsnow-menu.png": 13861,
	"./Keromb-menu.png": 99279,
	"./Kerosion-menu.png": 74541,
	"./Kolphur-menu.png": 66078,
	"./Krainnull-menu.png": 93093,
	"./Kroma-menu.png": 88311,
	"./Kromatice_(Extinction)-menu.png": 33713,
	"./Kromicide-menu.png": 2392,
	"./Krowr_(Extinction)-menu.png": 63729,
	"./Lamparos-menu.png": 5212,
	"./Larkito-menu.png": 86893,
	"./Leechy-menu.png": 5899,
	"./Lioness-menu.png": 69236,
	"./Lovidovi-menu.png": 84515,
	"./Lovinu-menu.png": 71258,
	"./Luhava_(Extinction)-menu.png": 571,
	"./Lukuma-menu.png": 95694,
	"./Lumbi-menu.png": 60156,
	"./Lume-menu.png": 48510,
	"./Lumefur-menu.png": 7389,
	"./Lumerei-menu.png": 11052,
	"./Lunabelle-menu.png": 12009,
	"./Lurkennie-menu.png": 15710,
	"./Lurkost-menu.png": 28933,
	"./Luxa_(Extinction)-menu.png": 97504,
	"./Lycopain_(Extinction)-menu.png": 40467,
	"./Madamusa-menu.png": 40340,
	"./Magnipub-menu.png": 4542,
	"./Malenostra-menu.png": 95015,
	"./Malevodo-menu.png": 9488,
	"./Malitress-menu.png": 5407,
	"./Mallark-menu.png": 55305,
	"./Mallish-menu.png": 24917,
	"./Mandrass_(Extinction)-menu.png": 79277,
	"./Mantoo-menu.png": 24137,
	"./Mantrass-menu.png": 1076,
	"./Mara-menu.png": 86036,
	"./Marasuma-menu.png": 33694,
	"./Maraudin-menu.png": 92126,
	"./Masqat-menu.png": 7404,
	"./Masquiti-menu.png": 28640,
	"./Mazecter-menu.png": 23816,
	"./Mearn-menu.png": 52738,
	"./Medlass-menu.png": 70188,
	"./Mermella-menu.png": 3306,
	"./Mimi-menu.png": 62831,
	"./Mimorus-menu.png": 87235,
	"./Minet-menu.png": 73670,
	"./Minetor-menu.png": 31575,
	"./Mistralion_(Extinction)-menu.png": 58894,
	"./Moga-menu.png": 10983,
	"./Mojompu-menu.png": 30154,
	"./Moltano-menu.png": 60195,
	"./Monkapow_(Extinction)-menu.png": 7888,
	"./Moonette-menu.png": 4796,
	"./Moonica-menu.png": 34899,
	"./Moonline-menu.png": 24476,
	"./Moonsting-menu.png": 6693,
	"./Moska-menu.png": 52358,
	"./Mound-menu.png": 2078,
	"./Mulcimer-menu.png": 33369,
	"./Muu-menu.png": 54234,
	"./Mystogen-menu.png": 53695,
	"./Nakazuru-menu.png": 19186,
	"./Namansi-menu.png": 41156,
	"./Nara_(Extinction)-menu.png": 88720,
	"./Navrigal-menu.png": 35255,
	"./Neglente-menu.png": 29053,
	"./Nekgiri-menu.png": 4404,
	"./Nekpanchi-menu.png": 6906,
	"./Ninstuff-menu.png": 63918,
	"./Nivalis-menu.png": 35211,
	"./Noki-menu.png": 52280,
	"./Noocidal-menu.png": 12938,
	"./Octollect-menu.png": 95082,
	"./Odiborg-menu.png": 72981,
	"./Ogoon_(Extinction)-menu.png": 76262,
	"./Omecharge-menu.png": 15464,
	"./Omentic-menu.png": 73510,
	"./Omepark-menu.png": 19652,
	"./Omnisun-menu.png": 87950,
	"./Onin-menu.png": 80237,
	"./Oregoon-menu.png": 64336,
	"./Oren-menu.png": 86181,
	"./Orgot-menu.png": 86510,
	"./Orologikus-menu.png": 72243,
	"./Ostrolt-menu.png": 99694,
	"./Outgrov-menu.png": 83127,
	"./Palsae-menu.png": 81111,
	"./Parchidna-menu.png": 81635,
	"./Paupo-menu.png": 6060,
	"./Pebglem-menu.png": 87973,
	"./Peltry-menu.png": 90741,
	"./Petram-menu.png": 93504,
	"./Phantra-menu.png": 34859,
	"./Ploriol-menu.png": 46212,
	"./Pluvean-menu.png": 20458,
	"./Pongo-menu.png": 48944,
	"./Ponic-menu.png": 41522,
	"./Pont-menu.png": 35768,
	"./Porklet-menu.png": 23180,
	"./Potpot-menu.png": 12005,
	"./Poyal-menu.png": 66810,
	"./Prankrow-menu.png": 98325,
	"./Prismazor_(Extinction)-menu.png": 69737,
	"./Protovados-menu.png": 42688,
	"./Puggard-menu.png": 76757,
	"./Quarauga-menu.png": 52396,
	"./Quarmor-menu.png": 9258,
	"./Raamu_(Extinction)-menu.png": 21122,
	"./Raksuma-menu.png": 45247,
	"./Rapi-menu.png": 77197,
	"./Rapilux-menu.png": 71408,
	"./Rapnux-menu.png": 51481,
	"./Rappub-menu.png": 33009,
	"./Reeferus-menu.png": 51190,
	"./Reptomotor-menu.png": 52344,
	"./Resonect_(Extinction)-menu.png": 68467,
	"./Resonic-menu.png": 56580,
	"./Ribombo-menu.png": 25405,
	"./Ripha-menu.png": 78007,
	"./Roclas-menu.png": 53287,
	"./Rotramus-menu.png": 94292,
	"./Rubby-menu.png": 23179,
	"./Runk-menu.png": 86901,
	"./Rust-menu.png": 39961,
	"./Rustu-menu.png": 56850,
	"./Rustung-menu.png": 62121,
	"./Sae-menu.png": 87680,
	"./Sakka-menu.png": 95630,
	"./Sandillo-menu.png": 42669,
	"./Scailla-menu.png": 51600,
	"./Scalder-menu.png": 24257,
	"./Scaratic-menu.png": 38587,
	"./Scooptor-menu.png": 6086,
	"./Sectoc-menu.png": 38894,
	"./Seedko-menu.png": 30184,
	"./Seedkorsky-menu.png": 89535,
	"./Senshizuru-menu.png": 27371,
	"./Shardberg-menu.png": 55909,
	"./Shardice-menu.png": 1240,
	"./Shardrillion-menu.png": 30726,
	"./Shardrine-menu.png": 46743,
	"./Shloom-menu.png": 27661,
	"./Shromboff-menu.png": 66739,
	"./Shrombrela-menu.png": 21642,
	"./Shromporo-menu.png": 96062,
	"./Siki-menu.png": 21507,
	"./Sikihob-menu.png": 72654,
	"./Sikipha-menu.png": 57796,
	"./Singlette-menu.png": 89420,
	"./Singletti-menu.png": 7640,
	"./Sirnymfa-menu.png": 45824,
	"./Skerdi-menu.png": 36909,
	"./Skounquet-menu.png": 86648,
	"./Skunqeau-menu.png": 72482,
	"./Skunqute-menu.png": 35275,
	"./Smanic-menu.png": 89064,
	"./Snaibble-menu.png": 31511,
	"./Snaiflow-menu.png": 6540,
	"./Snaijet-menu.png": 74089,
	"./Snush-menu.png": 87524,
	"./Solus-menu.png": 62725,
	"./Soniqo-menu.png": 8360,
	"./Sorvian-menu.png": 71493,
	"./Sounse-menu.png": 25498,
	"./Spektar-menu.png": 24845,
	"./Spikarm-menu.png": 84720,
	"./Spikus-menu.png": 37072,
	"./Stalagca-menu.png": 50313,
	"./Stalkee-menu.png": 14302,
	"./Starckal-menu.png": 18820,
	"./Stinger-menu.png": 66813,
	"./Streamoad-menu.png": 90363,
	"./Streamog-menu.png": 96161,
	"./Streamole-menu.png": 17861,
	"./Sulphlo-menu.png": 13002,
	"./Sunknight-menu.png": 55776,
	"./Sunnos-menu.png": 43477,
	"./Swactrum-menu.png": 71533,
	"./Swamplow-menu.png": 60273,
	"./Taipluff-menu.png": 44554,
	"./Tantrunt-menu.png": 9981,
	"./Tarragon-menu.png": 81733,
	"./Tephragon_(Extinction)-menu.png": 47646,
	"./Teslad-menu.png": 59802,
	"./Tesling-menu.png": 92983,
	"./Thornox-menu.png": 22269,
	"./Thrammer-menu.png": 37843,
	"./Tikala_(Extinction)-menu.png": 18560,
	"./Tiki-menu.png": 46592,
	"./Tiliamber-menu.png": 44800,
	"./Titan_(Extinction)-menu.png": 42514,
	"./Torrex_(Extinction)-menu.png": 66828,
	"./Trebly-menu.png": 52481,
	"./Treclay-menu.png": 21627,
	"./Tresaur-menu.png": 55493,
	"./Trondle_(Extinction)-menu.png": 73098,
	"./Tundri-menu.png": 55451,
	"./Tundrox-menu.png": 29897,
	"./Tuskant-menu.png": 91013,
	"./Tyrake-menu.png": 28005,
	"./Vados-menu.png": 30018,
	"./Vainok-menu.png": 29839,
	"./Vaprat_(Extinction)-menu.png": 70070,
	"./Varawirl-menu.png": 33917,
	"./Venefelis-menu.png": 43476,
	"./Ventra_(Extinction)-menu.png": 26394,
	"./Virox-menu.png": 32913,
	"./Vodo-menu.png": 48877,
	"./Volcel-menu.png": 25520,
	"./Volnamic-menu.png": 26688,
	"./Volpressor-menu.png": 64118,
	"./Volt-menu.png": 52072,
	"./Volta-menu.png": 91133,
	"./Voltaic-menu.png": 29537,
	"./Voltosfere_(Extinction)-menu.png": 57147,
	"./Wadgon-menu.png": 50459,
	"./Wadtail-menu.png": 97805,
	"./Wargoyle-menu.png": 82955,
	"./Waser-menu.png": 21121,
	"./Weavolt_(Extinction)-menu.png": 79640,
	"./Wiselie_(Extinction)-menu.png": 72390,
	"./Woozy-menu.png": 9297,
	"./Worb-menu.png": 33485,
	"./Wysil-menu.png": 12795,
	"./Wyverne-menu.png": 62675,
	"./Xotor-menu.png": 65949,
	"./Yarnesty-menu.png": 77366,
	"./Yomnom-menu.png": 12256,
	"./Yummo-menu.png": 39422,
	"./Zappnic-menu.png": 93778,
	"./Zasp-menu.png": 24601,
	"./Ziegler_(Extinction)-menu.png": 32208,
	"./Zumble-menu.png": 66526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83260;